export default {
  id: 4,
  title: 'Target #4 - Ups n Downs',
  url: 'https://cssbattle.dev/play/4',
  colors: ['#62306D', '#F7EC7D'],
  solution:
    '<a a><a b><a c><style>body{background:#62306D}a{position:fixed;background:#F7EC7D;width:100;height:100;border-radius:0 0 50% 50%}a[a]{top:50%;left:50}a[b]{top:50;left:150;transform:rotate(180deg)}a[c]{top:50%;right:50}</style>',
}
